export const GET_SEO = "GET_SEO"